var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { Entity } from '@decahedron/entity';
var tailwind = require('@/tailwind.config.js');
var ColorConfiguration = /** @class */ (function (_super) {
    __extends(ColorConfiguration, _super);
    function ColorConfiguration() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.footer = null;
        _this.footerBackground = null;
        _this.headingsAndTitles = null;
        _this.linksAndButtons = null;
        _this.logoBackground = null;
        return _this;
    }
    Object.defineProperty(ColorConfiguration.prototype, "headerBackground", {
        get: function () {
            return this.logoBackground || tailwind.theme.colors.purple;
        },
        enumerable: false,
        configurable: true
    });
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    ColorConfiguration.prototype.fromJson = function (jsonData) {
        var _a, _b, _c, _d, _e;
        _super.prototype.fromJson.call(this, jsonData);
        this.logoBackground = (_a = this.logoBackground) !== null && _a !== void 0 ? _a : tailwind.theme.colors.white;
        this.footer = (_b = this.footer) !== null && _b !== void 0 ? _b : tailwind.theme.colors.charcoal;
        this.footerBackground = (_c = this.footerBackground) !== null && _c !== void 0 ? _c : tailwind.theme.colors['light-gray'];
        this.linksAndButtons = (_d = this.linksAndButtons) !== null && _d !== void 0 ? _d : tailwind.theme.colors.purple;
        this.headingsAndTitles = (_e = this.headingsAndTitles) !== null && _e !== void 0 ? _e : tailwind.theme.colors.charcoal;
    };
    return ColorConfiguration;
}(Entity));
export { ColorConfiguration };
